import type { SVGProps } from 'react';

/**
 * Sparkline mit Trend-Pfeil — "noch keine Prognose".
 */
export function EmptyForecastsIllustration(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <line x1="20" y1="100" x2="108" y2="100" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      <line x1="20" y1="28" x2="20" y2="100" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      <path
        d="M26 86 L40 70 L52 78 L66 56 L80 64 L98 38"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="3 3"
        opacity="0.6"
      />
      <path
        d="M98 38 L96 46 M98 38 L106 40"
        className="text-brand-500"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="98" cy="38" r="3" className="text-brand-500" fill="currentColor" />
    </svg>
  );
}
